import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { DotMenuComponent, DotMenuEvent, DotMenuItem } from '../misc/dot-menu.component';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { CommonModule } from '@angular/common';
@Component({
    selector: 'title-toggle-wrapper',
    template: `
<div class="wrapper" [ngClass]="{ highlighted: highlighted, fitContent: fitContent }">
  <div class="header">
    <h3>{{ title }}</h3>
    <ng-content select=".title-slot"></ng-content>
    <div style="flex:1"></div>
    <ng-content select=".afterTitle"></ng-content>
    <div class="toggle-holder">
      <div class="toggle-text" [ngClass]="{selected: toggleOn}">{{ toggleStates[toggleOn ? 1 : 0] }}</div>
      <mat-slide-toggle *ngIf="!hideToggle" [disabled]="disabled" [ngClass]="{selected: toggleOn}" (change)="toggle.emit(!toggleOn)" [checked]="toggleOn"></mat-slide-toggle>
    </div>
    <dot-menu *ngIf="dotMenuItems" [dotMenuItems]="dotMenuItems" (select)="dotMenuSelection.emit($event)">
    </dot-menu>
  </div>
  <div class="content" *ngIf="!hideBottom">
    <ng-content></ng-content>
  </div>
</div>
`,
    styleUrls: ['title-toggle-wrapper.scss'],
    standalone: true,
    imports: [DotMenuComponent, MatSlideToggle, CommonModule],
})
export class TitleToggleComponent {
  @Input() title
  @Input() highlighted = false
  @Input() hideBottom = false
  @Input() fitContent = false
  @Input() toggleOn = false
  @Input() disabled = false
  @Input() hideToggle = false
  @Input() toggleStates = ['OFF', 'ON']
  @Input() dotMenuItems: DotMenuItem[]

  @Output() dotMenuSelection: EventEmitter<DotMenuEvent> = new EventEmitter()
  @Output() toggle: EventEmitter<boolean> = new EventEmitter()

}




